import { AuthIDTokenSupplier } from "./AuthIDTokenSupplier";
import { IDTokenSupplier } from "./IDTokenSupplier";

export class AuthIDTokenSupplierFactory {
    private static readonly INSTANCE: IDTokenSupplier = new AuthIDTokenSupplier();

    public static getInstance() {
        return this.INSTANCE;
    }
}